var a = { exports: {} };
export {
  a as __module
};
//# sourceMappingURL=index.es323.js.map
